























































import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Dialog from '@/shared/dialog/dialog'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { RenameResourceDialogInput } from '@/business/resource/components/rename-resource-dialog/rename-resource-dialog-input'
import { Prop } from 'vue-property-decorator'
import { TypedForm } from '@/shared/forms/typed-form'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { ResourceResponse } from '@/api/generated'
import { Injector } from '@/config/dependency-injection'
import { NotificationService } from '@/shared/services/notification-service'
import { ResourceModule } from '@/business/resource/store/resource-module'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { UPDATE_RESOURCE } from '@/business/resource/store/types'
import {
  RenameResourceForm,
  renameResourceFormMapping,
} from '@/business/resource/components/rename-resource-dialog/rename-resource-form'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'

@Component({
  name: 'rename-resource-dialog',
  components: {
    UnifyTextarea,
    UnifyButton,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoForm,
  },
})
export default class RenameResourceDialog extends Dialog<void>
  implements Hooks, RenameResourceDialogInput {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly resource!: ResourceViewModel

  public form!: TypedForm<ResourceViewModel, RenameResourceForm>

  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private resourceModule = Injector.get(ResourceModule)

  get loading(): boolean {
    return this.loaderHelper.isLoading(UPDATE_RESOURCE)
  }

  public data(): any {
    return {
      form: new TypedForm(renameResourceFormMapping(), this),
    }
  }

  public mounted(): void {
    this.form.reset(this.resource)
  }

  public validations() {
    return this.form.validations()
  }

  public dismiss() {
    this.dialogRef.dismiss().close()
  }

  public submit() {
    const model = this.form.serialize(this.resource)

    this.updateResource(model)
      .then(() => {
        this.dialogRef.close()
      })
      .catch(this.notificationService.errorHandler())
  }

  public updateResource(resource: ResourceViewModel): Promise<ResourceResponse> {
    return this.resourceModule.updateResource(resource)
  }
}
